import { observable, action, runInAction } from 'mobx'
import Api from '@api/hotel/ListModeApi'

class store {
  @observable hotelHalls = []
  @observable MerchantInfo = {}
  @action
  async getHotelHalls() {
    let { data } = await Api.getHotelHalls()
    runInAction('HotelHallsList', () => {
      this.hotelHalls = data && data[0] ? data : []
    })
  }
  @action
  async getMerchantInfo() {
    let { data } = await Api.getMerchantInfo()
    runInAction('MerchantInfo', () => {
      this.MerchantInfo = data
    })
  }
}

export default new store()
